import {DIGILOCKER_DATA_RESPONSE_LOADING,
    DIGILOCKER_DATA_RESPONSE_SUCCESS,
    DIGILOCKER_DATA_RESPONSE_FAILED,
    CHECK_DOC_RESPONSE_LOADING,
    CHECK_DOC_RESPONSE_SUCCESS,
    CHECK_DOC_RESPONSE_FAILED,
    UPLOAD_DIGI_DOC_LOADING,
    UPLOAD_DIGI_DOC_SUCCESS,
    UPLOAD_DIGI_DOC_FAILED
    
  } from "../Constants/digiLockerConstants";
  
  export const digiLockerDataReducer = (
    state = { digiLocakerData: [] },
    action
  ) => {
    switch (action.type) {
      case DIGILOCKER_DATA_RESPONSE_LOADING:
        return { loading: true, digiLocakerData: [] };
      case DIGILOCKER_DATA_RESPONSE_SUCCESS:
        return { loading: false, digiLocakerData: action.payload };
      case DIGILOCKER_DATA_RESPONSE_FAILED:
        return { loading: false, error: action.uanData };
      default:
        return state;
    }
  };

  export const checkDocReducer = (
    state = { checkDocData: [] },
    action
  ) => {
    switch (action.type) {
      case CHECK_DOC_RESPONSE_LOADING:
        return { loading: true, checkDocData: [] };
      case CHECK_DOC_RESPONSE_SUCCESS:
        return { loading: false, checkDocData: action.payload };
      case CHECK_DOC_RESPONSE_FAILED:
        return { loading: false, error: action.uanData };
      default:
        return state;
    }
  };

  export const UploadDigiDocReducer = (
    state = { uploadedDocData: [] },
    action
  ) => {
    switch (action.type) {
      case UPLOAD_DIGI_DOC_LOADING:
        return { loading: true, uploadedDocData: [] };
      case UPLOAD_DIGI_DOC_SUCCESS:
        return { loading: false, uploadedDocData: action.payload };
      case UPLOAD_DIGI_DOC_FAILED:
        return { loading: false, error: action.uanData };
      default:
        return state;
    }
  };

 